import { SalesChannel } from '@/types/auth';

export default function shouldShowContactAction(
  isUserExpired: boolean | undefined,
  salesChannel: SalesChannel,
  isTrial: boolean | undefined,
  isStripeEnabled: boolean
) {
  if (!isStripeEnabled) return true;
  if (isUserExpired) return false;
  if (isTrial) return salesChannel === SalesChannel.Sales;
  return true;
}
